"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyUserCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class IdentifyUserCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackIdentifyUserEvent(this.input);
    }
}
exports.IdentifyUserCommand = IdentifyUserCommand;
